import React, { useState } from 'react';
import General from '../components/settings/General';
import BlockedAddressesSettings from '../components/settings/FilterEmail';
import Profile from '../components/settings/Profile';

function MobileSetting() {
  const [activeTab, setActiveTab] = React.useState('general');
      const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);

      const tabs = [
        { id: 'general', label: 'General' },
        // { id: 'labels', label: 'Labels' },
        // { id: 'inbox', label: 'inbox' },
        // Named for what this tab actually renders: <Profile />, i.e. the first/last name form. It used to
        // be labelled "Accounts and import", advertising change-password, account delegation, address import
        // and 2FA — none of which exist anywhere in this app; that whole block is still commented out below.
        // Rest of the app already calls this screen "Profile Settings" (routes/Settings.js settingsTitle).
        { id: 'profile', label: 'Profile' },
        { id: 'blockedAddresses', label: 'Blocked Addresses' },
        // { id: 'forwardingAndPOPIMAP', label: 'Forwarding and POP/IMAP' },
        // { id: 'chatAndNotifications', label: 'Chat and notifications' },
        // { id: 'advanced', label: 'Advanced' },
        // { id: 'themes', label: 'Themes' },
      ];

      const handleTabClick = (tabId) => {
        setActiveTab(tabId);
      };

      const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
      };

      const closeDropdown = (e) => {
        if (!e.target.closest('#dropdownCover')) {
          setIsDropdownOpen(false);
        }
      };

      React.useEffect(() => {
        if (window.innerWidth >= 768) {
          window.addEventListener('click', closeDropdown);
          return () => window.removeEventListener('click', closeDropdown);
        }
      }, []);

      const TabContent = ({ id, children, title }) => (
        <div id={id} className={`tab-content ${activeTab === id ? 'tabPointer-active block' : 'd-none'}`}>
          <h2 className="setting-tab-heading text-black d-block d-md-none mb-2">{title}</h2>
          <div className="">{children}</div>
        </div>
      );

      const SettingRow = ({ label, description, children, minWidth = '130px' }) => (
        <div className="d-flex flex-column flex-xl-row align-items-xl-center gap-2 gap-md-4 setting-cards">
          <div style={{ minWidth }}>
            <h3 className="setting-labels">{label}</h3>
            {description && <h5>{description}</h5>}
          </div>
          <div className="d-flex align-items-center gap-2 flex-grow-1">{children}</div>
        </div>
      );


      const RadioOption = ({ name, id, label, checked }) => (
        <div className="d-flex align-items-center gap-2">
          <input className="input-radio" type="radio" name={name} id={id} defaultChecked={checked} />
          <label htmlFor={id} className="text-black block redio-label">{label}</label>
        </div>
      );

      const themes = [
        { bg: '#BBE5E4', label: 'Default', img: '/themes-bg.png' },
        { bg: '#BBE5E4' }, { bg: '#000000' }, { bg: '#B1D5EF' }, { bg: '#F7C5A0' },
        { bg: '#E2E8F0' }, { bg: '#FFD700' }, { bg: '#A0D995' }, { bg: '#BBE5E4' },
        { bg: '#FFA07A' }, { bg: '#90CDF4' }, { bg: '#98FB98' }, { bg: '#D8BFD8' },
        { bg: '#FFB6C1' }, { bg: '#C1FFC1' }, { bg: '#B0E0E6' }, { bg: '#ADD8E6' },
        { bg: '#BBE5E4' }, { bg: '#FFA500' }, { bg: '#F08080' }, { bg: '#87CEFA' },
        { bg: '#E9967A' }, { bg: '#AFEEEE' }, { bg: '#F0E68C' }, { bg: '#E6E6FA' },
        { bg: '#D3D3D3' }, { bg: '#FFE4E1' }, { bg: '#BBE5E4' },
      ];

  return (
   <section>
        {/* <div className='box-common-header box-header-type'>
          <div className="flex items-center gap-3">
            <svg className="d-block" xmlns="http://www.w3.org/2000/svg" width="8" height="17" fill="none">
              <path stroke="#202326" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m7 15.5-6-7 6-7" />
            </svg>
            <h1 className="main-heading">Settings</h1>
          </div>
        </div> */}
        <div className="px-3 pt-3">
          <div className="dataTabCover-items flex items-center flex-nowrap overflow-x-auto">
            {tabs.map((tab) => (
              <div
                key={tab.id}
                data-tab-target={`#${tab.id}`}
                className={`tab-pointer cursor-pointer text-nowrap ${activeTab === tab.id ? 'tabPointer-active' : ''}`}
                onClick={() => handleTabClick(tab.id)}
              >
                {tab.label}
              </div>
            ))}
          </div>
          <div className="mt-4">
            <div className="w-100">
              <TabContent id="general" title="General Settings">
                {/* <SettingRow label="Language :">
                  <h4 className="input-label d-none d-md-block">Dmail display language :</h4>
                  <select className="multiSelectOption-items">
                    <option>English (US)</option>
                    <option>option 1</option>
                    <option>option 2</option>
                  </select>
                </SettingRow>
                <SettingRow label="Phone Numbers :">
                  <h4 className="input-label d-none d-md-block">Default country code :</h4>
                  <select id="multiSelect-mobile" className="multiSelectOption-items">
                    <option>US</option>
                    <option>option 1</option>
                    <option>option 2</option>
                  </select>
                  <input type="text" placeholder="Enter phone number" id="multiSelect-none" className="multiSelectOption-items d-block d-md-none" />
                </SettingRow>
                <SettingRow label="Maximum page size :">
                  <h4 className="input-label d-none d-md-block">Show</h4>
                  <select className="multiSelectOption-items">
                    <option>50</option>
                    <option>option 1</option>
                    <option>option 2</option>
                  </select>
                  <h4 className="input-label d-none d-md-block">conversation per page</h4>
                </SettingRow>
                <SettingRow label="Undo Send :">
                  <h4 className="input-label d-none d-md-block">Send cancellation period:</h4>
                  <select className="multiSelectOption-items" style={{ minWidth: '100px' }}>
                    <option>50</option>
                    <option>option 1</option>
                    <option>option 2</option>
                  </select>
                  <h4 className="input-label d-none d-md-block">Seconds</h4>
                </SettingRow>
                <SettingRow label="Images :">
                  <div className="flex-column gap-2 d-none d-md-flex">
                    <RadioOption name="images-input" id="alwaysDisplay" label="Always display external images" checked />
                    <RadioOption name="images-input" id="beforeDisplaying" label="Ask before displaying external images" />
                  </div>
                  <select className="multiSelectOption-items d-block d-md-none">
                    <option>Always display external images</option>
                    <option>Ask before displaying external images</option>
                  </select>
                </SettingRow>
                <SettingRow label="Autocorrect :">
                  <div className="flex-column gap-2 d-none d-md-flex">
                    <RadioOption name="autocorrect" id="AutocorrectON" label="Autocorrect on" checked />
                    <RadioOption name="autocorrect" id="AutocorrectOFF" label="Autocorrect off" />
                  </div>
                  <select className="multiSelectOption-items d-block d-md-none">
                    <option>Autocorrect on</option>
                    <option>Autocorrect off</option>
                  </select>
                </SettingRow>
                <SettingRow label="Spelling :">
                  <div className="flex-column gap-2 d-none d-md-flex">
                    <RadioOption name="spelling-input" id="spellingON" label="Spelling suggestions on" checked />
                    <RadioOption name="spelling-input" id="spellingOFF" label="Spelling suggestions off" />
                  </div>
                  <select className="multiSelectOption-items d-block d-md-none">
                    <option>Spelling suggestions on</option>
                    <option>Spelling suggestions off</option>
                  </select>
                </SettingRow>
                <SettingRow label="Default reply behavior :">
                  <div className="flex-column gap-2 d-none d-md-flex">
                    <RadioOption name="default-reply" id="reply" label="Reply" checked />
                    <RadioOption name="default-reply" id="replyAll" label="Reply All" />
                  </div>
                  <select className="multiSelectOption-items d-block d-md-none">
                    <option>Reply</option>
                    <option>Reply All</option>
                  </select>
                </SettingRow>
                <SettingRow label="Hover actions :">
                  <div className="flex-column gap-2 d-none d-md-flex">
                    <RadioOption name="hoverActions" id="actionsEnable" label="Enable hover actions" checked />
                    <RadioOption name="hoverActions" id="actionsDisable" label="Disable hover actions" />
                  </div>
                  <select className="multiSelectOption-items d-block d-md-none">
                    <option>Enable hover actions</option>
                    <option>Disable hover actions</option>
                  </select>
                </SettingRow> */}
                <General />
              </TabContent>

              <TabContent id="labels" title="Labels Settings">
                <SettingRow label="Inbox :">
                  <div className="d-flex flex-column gap-2">
                    <RadioOption name="inboxInput" id="InboxShow" label="Show" checked />
                    <RadioOption name="inboxInput" id="Inboxhide" label="Hide" />
                  </div>
                </SettingRow>
                <SettingRow label="Outbox :">
                  <div className="d-flex flex-column gap-2">
                    <RadioOption name="OutboxInput" id="outboxShow" label="Show" checked />
                    <RadioOption name="OutboxInput" id="OutboxHide" label="Hide" />
                  </div>
                </SettingRow>
                <SettingRow label="Draft :">
                  <div className="d-flex flex-column gap-2">
                    <RadioOption name="draftInput" id="draftShow" label="Show" checked />
                    <RadioOption name="draftInput" id="draftHide" label="Hide" />
                  </div>
                </SettingRow>
                <SettingRow label="Important :">
                  <div className="d-flex flex-column gap-2">
                    <RadioOption name="importantInput" id="importantShow" label="Show" checked />
                    <RadioOption name="importantInput" id="importantHide" label="Hide" />
                  </div>
                </SettingRow>
              </TabContent>

              <TabContent id="inbox" title="Inbox Settings">
                <SettingRow label="Inbox type :">
                  <h4 className="input-label d-none d-md-block">Select inbox type</h4>
                  <select className="multiSelectOption-items">
                    <option>Default</option>
                    <option>option 1</option>
                    <option>option 2</option>
                  </select>
                </SettingRow>
                <SettingRow label="Dmail Preview Lines :">
                  <h4 className="input-label d-none d-md-block">Select preview lines</h4>
                  <select className="multiSelectOption-items">
                    <option>1</option>
                    <option>option 1</option>
                    <option>option 2</option>
                  </select>
                </SettingRow>
                <SettingRow label="Conversation View :">
                  <div className="d-flex flex-column gap-2">
                    <RadioOption name="conversationView" id="conversationViewEnable" label="Enable hover actions" checked />
                    <RadioOption name="conversationView" id="conversationViewDisable" label="Disable hover actions" />
                  </div>
                </SettingRow>
                <SettingRow label="Mark Dmails as Read :">
                  <div className="d-flex flex-column gap-2">
                    <RadioOption name="markDmailsRead" id="markDmailsReadEnable" label="Enable hover actions" checked />
                    <RadioOption name="markDmailsRead" id="markDmailsReadManually" label="Disable hover actions" />
                  </div>
                </SettingRow>
              </TabContent>

              <TabContent id="profile" title="Profile Settings">
                {/* <SettingRow label="Inbox type :" minWidth="210px">
                  <div className="d-flex flex-column flex-xl-row align-items-xl-center gap-3">
                    <div className="d-flex align-items-center gap-3">
                      <h4 className="input-label d-none d-md-block">Old password</h4>
                      <input type="text" placeholder="Old password" className="multiSelectOption-items" />
                    </div>
                    <div className="d-flex align-items-center gap-3">
                      <h4 className="input-label d-none d-md-block">New password</h4>
                      <input type="text" placeholder="New password" className="multiSelectOption-items" />
                    </div>
                    <h6 className="d-block d-md-none fs-6 fw-medium text-end" style={{ color: '#0B6DE0' }}>Save password</h6>
                  </div>
                </SettingRow>
                <SettingRow
                  label="Grant access to your account :"
                  description="(Mark as read)"
                >
                  <div className="d-flex flex-column gap-2">
                    <RadioOption
                      name="grantAccess"
                      id="grantAccessEnable"
                      label="Mark conversation as read when opened by others"
                      checked
                    />
                    <RadioOption
                      name="grantAccess"
                      id="grantAccessDisable"
                      label="Leave conversation as unread when opened by others"
                    />
                  </div>
                </SettingRow>

                <SettingRow label="Import dmail address :">
                  <div className="d-flex flex-column flex-xl-row align-items-xl-center gap-3">
                    <div className="d-flex align-items-center gap-3">
                      <h4 className="input-label d-none d-md-block">Username</h4>
                      <input type="text" placeholder="Username" className="multiSelectOption-items" />
                    </div>
                    <div className="d-flex align-items-center gap-3">
                      <h4 className="input-label d-none d-md-block">Dmail address</h4>
                      <input type="text" placeholder="Dmail address" className="multiSelectOption-items" />
                    </div>
                    <h6 className="d-block d-md-none fs-6 fw-medium text-end" style={{ color: '#0B6DE0' }}>Import</h6>
                  </div>
                </SettingRow>
                <SettingRow label="Two-Factor Authentication (2FA) :">
                  <div className="d-flex flex-column gap-2">
                    <RadioOption name="twoFactor" id="twoFactorON" label="ON" checked />
                    <RadioOption name="twoFactor" id="twoFactorOFF" label="OFF" />
                  </div>
                </SettingRow> */}
                
                  <Profile />
              </TabContent>

              <TabContent id="blockedAddresses" title="Blocked address settings">
                {/* <div className="d-flex flex-column flex-md-row align-items-start py-3 gap-3">
                  <h3 className="setting-labels" style={{ maxWidth: '210px' }}>
                    The following dmail addresses are blocked. Messages from these addresses will not appear in inbox:
                  </h3>
                  <div className="flex-grow-1 w-100">
                    {Array(6).fill().map((_, index) => (
                      <div key={index} className="d-flex align-items-center justify-content-between gap-3 px-2 py-2" style={{ borderBottom: '1px solid #f5f5f5' }}>
                        <div className="d-flex align-items-center gap-2">
                          <img className="rounded-circle object-fit-cover" style={{ width: '30px', height: '30px', minWidth: '30px' }} src="/user.png" alt="" />
                          <div>
                            <h4 className="setting-username">Username</h4>
                            <h5 className="setting-user-email" style={{ fontSize: '10px', color: '#36494D' }}>user@dmail.nec</h5>
                          </div>
                        </div>
                        <button className="cursor-pointer" style={{ color: '#F04438', fontSize: '10px', fontWeight: '500', border: 'none', backgroundColor: 'transparent' }}>Unblock</button>
                      </div>
                    ))}
                  </div>
                </div> */}
                <BlockedAddressesSettings />
              </TabContent>

              <TabContent id="forwardingAndPOPIMAP" title="Forwarding and POP/IMAP">
                <SettingRow label="Forwarding :">
                  <h4 className="input-label d-none d-md-block">Add forwarding address :</h4>
                  <input type="text" placeholder="Enter mail address" className="multiSelectOption-items" />
                  </SettingRow>
                  <SettingRow
                    label="POP download"
                    description="(status):"
                  >
                  <div className="d-flex flex-column gap-2">
                    <RadioOption name="POPdownload" id="POPdownloadEnable" label="Enable POP for all mails" checked />
                    <RadioOption name="POPdownload" id="POPdownloadArrives" label="Enable POP for mails that arrives from now on" />
                  </div>
                </SettingRow>
                <SettingRow label="IMAP access :">
                  <div className="d-flex flex-column gap-2">
                    <h4 className="input-label">When I mark a message in IMAP as deleted</h4>
                    <RadioOption name="autoExpunge-input" id="autoExpungeEnable" label="Auto-Expunge off - Wait for the client to update the server" checked />
                    <RadioOption name="autoExpunge-input" id="autoExpungeArrives" label="Auto-Expunge on - Immediately update the server. (default)" />
                    <h4 className="input-label mt-2">Folder size limits</h4>
                    <RadioOption name="folderSizeLimits" id="folderSizeLimitsEnable" label="Do not limit the number of messages in an IMAP folder (default)" checked />
                    <RadioOption name="folderSizeLimits" id="folderSizeLimitsArrives" label="Limit IMAP folders to contain no more than this many messages" />
                    <select className="multiSelectOption-items mobile-settings-text-small-padding">
                      <option>1,000</option>
                      <option>option 1</option>
                      <option>option 2</option>
                    </select>
                  </div>
                </SettingRow>
              </TabContent>

              <TabContent id="chatAndNotifications" title="Chat and notifications settings">
                <SettingRow label="Chat settings :" minWidth="190px">
                  <div className="d-flex flex-column gap-2">
                    <RadioOption name="chatSettingsInput" id="chatSettingsInputShow" label="ON" checked />
                    <RadioOption name="chatSettingsInput" id="chatSettingsInputHide" label="OFF" />
                  </div>
                </SettingRow>
                <SettingRow label="Allow chat from :" minWidth="190px">
                  <div className="d-flex flex-column gap-2">
                    <RadioOption name="allowChatFrom" id="allowChatFromShow" label="All DContacts" />
                    <RadioOption name="allowChatFrom" id="allowChatFromHide" label="All Dchats" checked />
                    <RadioOption name="allowChatFrom" id="allowChatFromNobody" label="No body" />
                  </div>
                </SettingRow>
                <SettingRow label="Mute Notifications During Dmail Focus :" minWidth="190px">
                  <div className="d-flex flex-column gap-2">
                    <RadioOption name="muteNotifications" id="muteNotificationsShow" label="ON" checked />
                    <RadioOption name="muteNotifications" id="muteNotificationsHide" label="OFF" />
                  </div>
                </SettingRow>
              </TabContent>

              <TabContent id="advanced" title="Advance settings">
                <SettingRow label="Auto-Save Drafts While Typing :" minWidth="190px">
                  <div className="d-flex flex-column gap-2">
                    <RadioOption name="autoSaveDraftsInput" id="autoSaveDraftsShow" label="Enable" checked />
                    <RadioOption name="autoSaveDraftsInput" id="autoSaveDraftsHide" label="Disable" />
                  </div>
                </SettingRow>
                <SettingRow label="Confirm Before Sending Encrypted mails :" minWidth="190px">
                  <div className="d-flex flex-column gap-2">
                    <RadioOption name="confirmBeforeInput" id="confirmBeforeShow" label="Enable" checked />
                    <RadioOption name="confirmBeforeInput" id="confirmBeforeHide" label="Disable" />
                  </div>
                </SettingRow>
                <SettingRow label="Offline mails :" minWidth="190px">
                  <div className="d-flex flex-column gap-2">
                    <RadioOption name="offlineMailsInput" id="offlineMailsShow" label="Enable" checked />
                    <RadioOption name="offlineMailsInput" id="offlineMailsHide" label="Disable" />
                  </div>
                </SettingRow>
                <SettingRow label="Custom keyboard shortcuts :" minWidth="190px">
                  <div className="d-flex flex-column gap-2">
                    <RadioOption name="customKeyboardInput" id="customKeyboardShow" label="Enable" checked />
                    <RadioOption name="customKeyboardInput" id="customKeyboardHide" label="Disable" />
                  </div>
                </SettingRow>
                <SettingRow label="Unread message icon :" minWidth="190px">
                  <div className="d-flex flex-column gap-2">
                    <RadioOption name="unreadMessageInput" id="unreadMessageShow" label="Enable" checked />
                    <RadioOption name="unreadMessageInput" id="unreadMessageHide" label="Disable" />
                  </div>
                </SettingRow>
              </TabContent>

              <TabContent id="themes" title="Theme settings">
                <SettingRow label="Themes :">
                  <h4 className="input-label d-none d-md-block">Set theme :</h4>
                  <div className="position-relative flex-grow-1 max-width-640" id="dropdownCover">
                    <button
                      id="dropdownButton"
                      type="button"
                      className="d-none d-md-flex align-items-center justify-content-between"
                      onClick={toggleDropdown}
                    >
                      Select Option
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" fill="none">
                        <path stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeOpacity=".38" strokeWidth="2" d="M11 1 6 6 1 1" />
                      </svg>
                    </button>
                    <div
                      id="dropdownMenu"
                      className={`w-100 mt-2 p-1 p-md-2 bg-white border rounded shadow mobile-settings-custom-box ${isDropdownOpen ? '' : 'dropdown-cover d-none'}`}
                    >
                      <div className="d-flex flex-wrap gap-2 gap-md-3 mobile-settings-scrollable-max-460">
                        {themes.map((theme, index) => (
                          <div
                            key={index}
                            className={`cursor-pointer position-relative ${theme.label === 'Default' ? 'setTheme-active' : ''}`}
                            style={{ width: '99px', height: '80px', backgroundColor: theme.bg }}
                          >
                            {theme.img && <img className="w-100 h-100 object-fit-cover" src={theme.img} alt="" />}
                            {theme.label === 'Default' && (
                              <>
                                <svg
                                  className="d-block d-md-none position-absolute centered-overlay"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  fill="none"
                                >
                                  <path
                                    fill="url(#a)"
                                    d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0ZM8 15l-5-5 1.41-1.41L8 12.17l7.59-7.59L17 6l-9 9Z"
                                  />
                                  <defs>
                                    <linearGradient id="a" x1="10" x2="10" y1="0" y2="20" gradientUnits="userSpaceOnUse">
                                      <stop stopColor="#18F06E" />
                                      <stop offset="1" stopColor="#0B6DE0" />
                                    </linearGradient>
                                  </defs>
                                </svg>
                                <h5 className="position-absolute bottom-0 text-white fw-normal centered-x-small-text">
                                  Default
                                </h5>
                              </>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </SettingRow>
              </TabContent>
            </div>
          </div>
        </div>

    </section>
  );
}

export default MobileSetting;
